import { render, staticRenderFns } from "./websiteAccess.vue?vue&type=template&id=5c183a37&scoped=true"
import script from "./websiteAccess.vue?vue&type=script&lang=js"
export * from "./websiteAccess.vue?vue&type=script&lang=js"
import style0 from "./websiteAccess.vue?vue&type=style&index=0&id=5c183a37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c183a37",
  null
  
)

export default component.exports